import { getStorage, ref as storageRef, getDownloadURL } from 'firebase/storage';
import { resolveAccountIdFromSlug } from './accountPaths';

const normalizeSlug = (value) => (value || '').toString().trim().toLowerCase();

async function tryGet(paths) {
  const storage = getStorage();
  for (const p of paths) {
    try {
      const ref = storageRef(storage, p);
      return await getDownloadURL(ref);
    } catch (_) {
      // tenta próximo
    }
  }
  return '';
}

export async function getDueLogoUrl() {
  return await tryGet([
    // raiz do bucket
    'logo.png', 'logo.jpeg', 'logo.jpg',
  ]);
}

export async function getDueFooterLogoUrl() {
  return await tryGet([
    // raiz do bucket
    'logo1.png', 'logo1.jpeg', 'logo1.jpg',
  ]);
}

export async function getLogoUrl(cliente) {
  const c = normalizeSlug(cliente);
  if (!c) return '';
  const accountId = resolveAccountIdFromSlug(c);
  const paths = [
    `accounts/${accountId}/logo.png`,
    `accounts/${accountId}/logo.jpg`,
    `accounts/${accountId}/logo.jpeg`,
  ];
  return await tryGet(paths);
}
